var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepleLikeI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93246 10.4321C6.57555 10.4321 6.28789 10.7199 6.28789 11.0754C6.28789 11.431 6.57618 11.7187 6.93246 11.7187C12.8929 11.7187 17.2664 16.1236 17.2664 22.0714C17.2664 22.427 17.5547 22.7141 17.911 22.7141C18.2672 22.7141 18.5555 22.4264 18.5555 22.0714C18.5555 15.3899 13.6275 10.4321 6.93246 10.4321ZM6.93812 4.00063C6.58185 4.00063 6.29355 4.28834 6.29355 4.6439C6.29355 4.99947 6.58185 5.28718 6.93812 5.28718C16.1869 5.28718 23.7109 12.7961 23.7109 22.0256C23.7109 22.3811 23.9991 22.6682 24.3554 22.6682C24.7117 22.6682 25 22.3805 25 22.0256C25 12.0862 16.8975 4 6.93812 4V4.00063ZM8.5483 16.8976C6.59192 16.8976 5 18.4901 5 20.4482C5 22.4056 6.59192 24 8.54767 24C10.5034 24 12.0966 22.4063 12.0966 20.4488C12.0966 18.4907 10.5047 16.8982 8.5483 16.8982V16.8976ZM8.5483 22.7562C7.27741 22.7562 6.24319 21.7209 6.24319 20.4482C6.24319 19.1754 7.27741 18.1408 8.5483 18.1408C9.81919 18.1408 10.854 19.1761 10.854 20.4482C10.854 21.7203 9.81982 22.7562 8.5483 22.7562Z",
    fill: "#0F1A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepleLikeI);
export default __webpack_public_path__ + "static/media/peple-like-i.88eda15d3c7fa3e0d14a8b49ef086ba8.svg";
export { ForwardRef as ReactComponent };